import { useState, useEffect } from 'react';
import axios from 'axios';

interface OverdueStatus {
  hasOverdue: boolean;
}

export const useOverdueStatus = () => {
  const [hasOverdue, setHasOverdue] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOverdueStatus = async () => {
      try {
        setLoading(true);
        
        // Endpoint simples, acessível a todos os usuários autenticados
        const response = await axios.get('/billing/has-overdue');
        
        if (response.data.success) {
          setHasOverdue(response.data.hasOverdue);
        }
      } catch (err: any) {
        console.error('Error fetching overdue status:', err);
        // Se der erro, não mostra alerta
        setHasOverdue(false);
      } finally {
        setLoading(false);
      }
    };

    fetchOverdueStatus();
  }, []);

  return { hasOverdue, loading };
};

